var exports = {
  "h": "x04b3a21e--1e311e--description",
};

module.exports = exports;
